import { EventEmitter } from '@angular/core';

export class PaginatorModel {
  constructor() {
    this._length = 0;
    this._pageIndex = 0;
    this._pageSize = 10;
    this._pageSizeOptions = [10, 20, 50];
    this._propertyChange = new EventEmitter<{ key: string; value: number | number[] }>();
  }

  private _propertyChange: EventEmitter<{ key: string; value: number | number[] }>;

  get propertyChange() {
    return this._propertyChange;
  }

  private _length: number;

  get length(): number {
    return this._length;
  }

  set length(value: number) {
    this._length = value;
    this.propertyChange.emit({
      key: 'length',
      value: value,
    });
  }

  private _pageIndex: number;

  get pageIndex(): number {
    return this._pageIndex;
  }

  set pageIndex(value: number) {
    this._pageIndex = value;
    this.propertyChange.emit({
      key: 'pageIndex',
      value: value,
    });
  }

  private _pageSize: number;

  get pageSize(): number {
    return this._pageSize;
  }

  set pageSize(value: number) {
    this._pageSize = value;
    this.propertyChange.emit({
      key: 'pageSize',
      value: value,
    });
  }

  private _pageSizeOptions: number[];

  get pageSizeOptions(): number[] {
    return this._pageSizeOptions;
  }

  set pageSizeOptions(value: number[]) {
    this._pageSizeOptions = value;
    this.propertyChange.emit({
      key: 'pageSizeOptions',
      value: value,
    });
  }
}
